export const API_BASE_PATH = "/apiv2/";
export const API_DEFAULT_PAGE_SIZE = 10;
export const API_AVAILABLE_PAGE_SIZES = [10, 30, 50, 100];


export const getIntervalTranslation = (val, count) => {

    switch (val) {
        case 'day':
            return ngettext(
                'day',
                'days',
                count
            );
        case 'week':
            return ngettext(
                'week',
                'weeks',
                count
            );
        case 'month':
            return ngettext(
                'month',
                'months',
                count
            );
        case 'year':
            return ngettext(
                'year',
                'years',
                count
            );
        default:
            return val;
    }
}

export const getDescriptivePaymentProcessorName = (val) => {
    switch(val) {
        case 'valitorpay':
            return 'ValitorPay'
        case 'saltpay':
            return 'SaltPay'
        default:
            return val;
    }
}